import { LiveboardEmbed } from '@thoughtspot/visual-embed-sdk/lib/src/react'
import cx from 'classnames'

import { selectLeftPanelVisibility } from 'common/components/leftPanel/store/leftPanelSlice'
import PageContainer from 'common/components/PageContainer'
import { useAppSelector } from 'common/hooks/redux'

import LeftSection from './LeftSection'
import { EMBED_CLASS_NAME } from './styles'

export const Liveboard = () => {
  const liveboardId = useAppSelector(
    (state) => state.reports.selectedLiveboardId
  )

  const leftPanelVisibility = useAppSelector(selectLeftPanelVisibility)

  return (
    <div
      className={cx('relative overflow-y-auto overflow-x-hidden flex h-full', {
        'ml-30': leftPanelVisibility === 'hidden',
      })}
    >
      <LeftSection />
      <PageContainer>
        <LiveboardEmbed
          className={EMBED_CLASS_NAME}
          liveboardId={liveboardId}
        />
      </PageContainer>
    </div>
  )
}
